// MealPlan.js
import React, { useState } from 'react';
import './KitchenDashboard.css';
import { useKitchenData } from './Context/KitchenDataContext';
import KitchenSidebar from './KitchenSidebar';

const MealPlan = () => {
  const { getMealsForDay, getIngredientsForDay } = useKitchenData();
  const [date, setDate] = useState(new Date());
  const [tab, setTab] = useState('meals');
  
  const dateStr = date.toISOString().split('T')[0];
  const mealsForDay = getMealsForDay(dateStr);
  const ingredientsForDay = getIngredientsForDay(dateStr);

  return (
    <div className="kitchen-layout">
      <KitchenSidebar />
      <div className="meal-planning-content">
        <div className="meal-planning-header">
          <div>
            <h1 className="meal-planning-title">Meal Planning</h1>
            <div className="meal-planning-subtitle">
              Food requirements for {date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
            </div>
          </div>
          <div className="date-controls">
            <button className="date-nav-btn" onClick={() => { 
              const d = new Date(date); 
              d.setDate(d.getDate() - 1); 
              setDate(d); 
            }}>◀</button>
            <div className="date-display">
              <span className="date-day">
                {date.toLocaleDateString('en-US', { weekday: 'long' })}, {date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' })}
              </span>
            </div>
            <button className="date-nav-btn" onClick={() => { 
              const d = new Date(date); 
              d.setDate(d.getDate() + 1); 
              setDate(d); 
            }}>▶</button>
          </div>
        </div>

        <div className="meal-planning-tabs">
          <button 
            className={`meal-tab ${tab === 'meals' ? 'active' : ''}`} 
            onClick={() => setTab('meals')}
          >
            Meals to Prepare ({mealsForDay.length})
          </button>
          <button 
            className={`meal-tab ${tab === 'ingredients' ? 'active' : ''}`} 
            onClick={() => setTab('ingredients')}
          >
            Ingredients Needed ({ingredientsForDay.length})
          </button>
        </div>

        <div className="meal-planning-body">
          {tab === 'meals' ? (
            <div className="meals-grid">
              {mealsForDay.length > 0 ? (
                mealsForDay.map(meal => (
                  <div key={meal.code} className="meal-card">
                    <div className="meal-card-header">
                      <div className="meal-title-section">
                        <h3 className="meal-name">{meal.name}</h3>
                        <span className="meal-code">{meal.code}</span>
                      </div>
                      <span className="meal-quantity">x{meal.quantity}</span>
                    </div>
                    
                    <p className="meal-description">{meal.description}</p>
                    
                    {meal.nutrition && (
                      <div className="nutrition-info">
                        <div className="nutrition-item">
                          <span className="nutrition-label">Cal</span>
                          <span className="nutrition-value">{meal.nutrition.calories * meal.quantity}</span>
                        </div>
                        <div className="nutrition-item">
                          <span className="nutrition-label">Protein</span>
                          <span className="nutrition-value">{(meal.nutrition.protein * meal.quantity).toFixed(1)}g</span>
                        </div>
                        <div className="nutrition-item">
                          <span className="nutrition-label">Carbs</span>
                          <span className="nutrition-value">{(meal.nutrition.carbs * meal.quantity).toFixed(1)}g</span>
                        </div>
                        <div className="nutrition-item">
                          <span className="nutrition-label">Fat</span>
                          <span className="nutrition-value">{(meal.nutrition.fat * meal.quantity).toFixed(1)}g</span>
                        </div>
                      </div>
                    )}

                    {meal.ingredients && (
                      <div className="ingredients-section">
                        <h4 className="ingredients-title">Ingredients (per serving):</h4>
                        <ul className="ingredients-list">
                          {meal.ingredients.map((ingredient, idx) => (
                            <li key={idx} className="ingredient-item">
                              {ingredient.name}: {ingredient.qty} {ingredient.unit}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '40px', 
                  color: '#666',
                  gridColumn: '1 / -1'
                }}>
                  <h3>No meals scheduled for this date</h3>
                  <p>Add some diet plans to see meals here.</p>
                </div>
              )}
            </div>
          ) : (
            <div className="ingredients-view">
              {ingredientsForDay.length > 0 ? (
                <div className="ingredients-grid">
                  {ingredientsForDay.map((ingredient, idx) => (
                    <div key={idx} className="ingredient-row">
                      <span className="ingredient-name">{ingredient.name}</span>
                      <span className="ingredient-qty">{ingredient.qty}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '40px', 
                  color: '#666' 
                }}>
                  <h3>No ingredients needed for this date</h3>
                  <p>Add some diet plans to see ingredient requirements here.</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MealPlan;